<h2>Recebimentos</h2>

<div class="tds-row">
  <app-button text="Criar recebimento" (clicked)="create()"></app-button>
</div>

<div class="tds-row">
  <tds-datetime
    class="tds-u-mr2"
    type="date"
    label="Data Entrada"
    label-position="inside"
    [(ngModel)]="dataEntrada"
  ></tds-datetime>
  <tds-datetime
    class="tds-u-mr2"
    type="date"
    label="Data Saída"
    label-position="inside"
    [(ngModel)]="dataSaida"
  ></tds-datetime>
  <app-input
    label="Fornecedor"
    [(ngModel)]="fornecedor"
    (keydown.enter)="search()"
  ></app-input>
  <app-input
    label="Nota Fiscal"
    [(ngModel)]="notaFiscal"
    (keydown.enter)="search()"
  ></app-input>
  <app-input
    label="Direcionamento"
    [(ngModel)]="direcionamento"
    (keydown.enter)="search()"
  ></app-input>
  <app-input
    label="Registro"
    [(ngModel)]="registro"
    (keydown.enter)="search()"
  ></app-input>
  <app-input
    label="Senha"
    [(ngModel)]="senha"
    (keydown.enter)="search()"
  ></app-input>
  <app-button
    class="tds-u-ml1"
    text="Pesquisar"
    (clicked)="search()"
  ></app-button>
</div>

<app-table
  [headers]="headers"
  [content]="recebimentoList"
  [showFilter]="true"
  [hasEdit]="true"
  [hasDelete]="true"
  (editing)="edit($event)"
  (deleting)="confirmDelete($event)"
>
</app-table>
